import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import RequestService from '@tcc-online/request-service';
import { NotificationActions } from '../../common/actions/NotificationActions';
import Participant360 from '../types/project/360/Participant360';
import Evaluator from '../types/project/360/Evaluator';

const Admin360ParticipantService = {
    getParticipants,
    getParticipant,
    createParticipant,
    deleteParticipant,
    getEvaluators,
    getEvaluator,
    createEvaluator,
    editEvaluator,
    deleteEvaluator,
};

const createUrl = (projectId: number, participantId?: number) => {
    let url = `/admin/products/360/projects/${projectId}/participants`;
    if (participantId) {
        url += `/${participantId}`;
    }

    return url;
};

interface BasePayload {
    projectId: number;
}

async function getParticipants(
    payload: BasePayload,
    thunkApi?: GetThunkAPI<any>,
) {
    try {
        return await RequestService.get<Participant360[]>(
            createUrl(payload.projectId),
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist ucastniky'),
        ); // TODO: translate

        throw e;
    }
}

export interface ParticipantPayload extends BasePayload {
    participantId: number;
}

async function getParticipant(
    payload: ParticipantPayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { projectId, participantId } = payload;
    try {
        return await RequestService.get<Participant360>(
            createUrl(projectId, participantId),
        );
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se nacist ucastnika'),
        ); // TODO: translate

        throw e;
    }
}

interface CreatePayload {
    email?: string;
    id?: number;
}

async function createParticipant(
    payload: CreatePayload & BasePayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { projectId, email, id } = payload;
    try {
        return await RequestService.post<CreatePayload, Participant360>(
            createUrl(projectId),
            { email, id },
        );
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se vytvorit ucastnika'),
        ); // TODO: translate

        throw e;
    }
}

async function deleteParticipant(
    payload: ParticipantPayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { projectId, participantId } = payload;
    try {
        return await RequestService.delete(createUrl(projectId, participantId));
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se smazat ucastnika'),
        ); // TODO: translate

        throw e;
    }
}

const createEvaluatorUrl = (
    projectId: number,
    participantId: number,
    evaluatorId?: number,
) => {
    let url = `${createUrl(projectId, participantId)}/evaluators`;
    if (evaluatorId) {
        url += `/${evaluatorId}`;
    }

    return url;
};

async function getEvaluators(
    payload: ParticipantPayload,
    thunkApi?: GetThunkAPI<any>,
) {
    try {
        return await RequestService.get<Evaluator[]>(
            createEvaluatorUrl(payload.projectId, payload.participantId),
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist hodnotitele'),
        ); // TODO: translate

        throw e;
    }
}

export interface EvaluatorPayload extends ParticipantPayload {
    evaluatorId: number;
}

async function getEvaluator(
    payload: EvaluatorPayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { projectId, participantId, evaluatorId } = payload;
    try {
        return await RequestService.get<Evaluator>(
            createEvaluatorUrl(projectId, participantId, evaluatorId),
        );
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se nacist hodnotitele'),
        ); // TODO: translate

        throw e;
    }
}

export interface CreateEvaluatorPayload {
    email?: string;
    id?: number;
    relationship: string;
}

async function createEvaluator(
    payload: CreateEvaluatorPayload & ParticipantPayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { projectId, participantId, email, id, relationship } = payload;
    try {
        return await RequestService.post<CreateEvaluatorPayload, Evaluator>(
            createEvaluatorUrl(projectId, participantId),
            { email, id, relationship },
        );
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se vytvorit hodnotitele'),
        ); // TODO: translate

        throw e;
    }
}

export interface EditEvaluatorPayload {
    relationship: string;
}

async function editEvaluator(
    payload: EditEvaluatorPayload & EvaluatorPayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { projectId, participantId, evaluatorId, relationship } = payload;
    try {
        return await RequestService.patch<EditEvaluatorPayload, Evaluator>(
            createEvaluatorUrl(projectId, participantId, evaluatorId),
            {
                relationship,
            },
        );
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se upravit hodnotitele'),
        ); // TODO: translate

        throw e;
    }
}

async function deleteEvaluator(
    payload: EvaluatorPayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { projectId, participantId, evaluatorId } = payload;
    try {
        return await RequestService.delete(
            createEvaluatorUrl(projectId, participantId, evaluatorId),
        );
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se smazat hodnotitele'),
        ); // TODO: translate

        throw e;
    }
}

export default Admin360ParticipantService;
